<!--
 * @description: 门店位置
 * @fileName: storeMap.vue
 * @author: WePunk
 * @date: 2024-06-13 14:20:20
!-->
<template>
    <div class="map-container" ref="mapContainer">
        <van-nav-bar :border="false" left-arrow class="map-navbar" @click-left="onClickLeft" @click-reft="onClickRight">
            <template #title>
                <div class="nav-title">{{ title }}</div>
            </template>
            <template #right>
                <div v-show="!searchTop" class="submitPos" :style="{ color: point ? '#08BB5A' : '#999999' }"
                    @click="onClickRight">确定</div>
            </template>
        </van-nav-bar>
        <div class="map-rela">
            <div id="container" class="map-store"></div>
            <!-- 定位控件 -->
            <div class="position-control" @click="onClickPosition">
                <div class="icon"></div>
            </div>
        </div>
        <div class="search-map" :class="{ istop: searchTop }">
            <div class="flex">
                <van-search v-model="searchValue" class="search-box" @focus="searchFocus" @blur="searchBlur" placeholder="搜索药店所在地点" />
                <div v-show="searchTop" class="cancel" @click="searchTop = false">取消</div>
            </div>
            <div class="result-map">
                <div class="result-item" v-for="(item, index) in list" :class="{ activeMap: index === pointActive }"
                    @click="onClickResult(item, index)" :key="index">
                    <div class="result-name" v-html="item.title"></div>
                    <div class="result-address">{{ item.address }}</div>
                    <van-icon v-show="index === pointActive" size="24" class="result-icon" name="success" />
                </div>
                <div v-show="list.length === 0" class="no-result">
                    暂无地点信息
                </div>
            </div>
        </div>
        <van-overlay z-index="12" :show="loading">
            <div class="loading-box">
                <van-loading type="spinner" color="#ffffff" vertical>加载中...</van-loading>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import { loadBaiDuMap } from "@/utils/baiduMapGL"
import { Loading, Toast, Sticky } from "vant"
import { disLimitGet, disLimitUpdate } from "@/api"
import { getCookie } from '@/utils/auth'
import { getIsIos } from '@/utils/index'
import pointIcon from "../../icons/pos-location.png"
import { getIOSVersion } from '@/utils/index'


export default {
    components: {
        vanSticky: Sticky,
        vanLoading: Loading
    },
    data() {
        return {
            title: '设置门店位置',
            searchValue: '',
            BMapGL: null,
            map: null,
            loading: false,
            pointActive: null,
            point: {},
            location: {},
            searchLocal: null,
            searchTop: false, // 是否搜索框置顶
            list: []
        }
    },
    mounted() {
        // 初始化地图
        this.getDistanceLimit()
    },
    methods: {
        async initMap(address) {
            const BMapGL = await loadBaiDuMap();
            const map = new BMapGL.Map('container'); // 创建Map实例

            const point = new BMapGL.Point(this.point.lng || 116.404, this.point.lat || 39.915); // 创建点坐标
            map.centerAndZoom(point, 16);
            map.enableScrollWheelZoom(); // 启

            this.BMapGL = BMapGL;
            this.map = map;
            this.searchLocal = new this.BMapGL.LocalSearch(this.map, {
                onSearchComplete: this.mapSearch
            })
            this.searchValue && this.searchLocal.search(this.searchValue)

            if(address){
                const posIcon = new BMapGL.Icon(pointIcon, new BMapGL.Size(30, 60));
                const marker = new BMapGL.Marker(point, { icon: posIcon });    
                map.clearOverlays()
                const geocoder = new BMapGL.Geocoder();
                geocoder.getLocation(point, result => {
                    map.addOverlay(marker)
                    map.centerAndZoom(point, 18)
                    if (!result) return;
                    this.pointActive = null;
                    const list = [];
                    for (let i = 0; i < result.surroundingPois.length; i++) {
                        const item = result.surroundingPois[i];
                        const regex = new RegExp(`(${this.searchValue})`, 'gi');
                        item.title = item.title.replace(regex, '<span style="color:#00B955">$1</span>')
                        list.push(item);
                    }
                    this.list = list;
                    if(list.length){
                        this.onClickResult({ point: list[0].point }, 0)
                    }
                });
            }
        },
        async getDistanceLimit() {
            this.loading = true;
            const ret = await disLimitGet({ organSign: getCookie('native_organSign') })
            .catch(err =>  console.log("接口请求失败", err));
            this.loading = false;
            if (!ret) return this.initMap();
            const { data } = ret
            
            if (data.result) {
                const { latitude, longitude, mapLocationAddress } = data.result
                this.point = {
                    lng: longitude,
                    lat: latitude,
                    address: mapLocationAddress,
                }
            }
            this.initMap(this.point.address)
        },

        // 搜索地理位置
        mapSearch(results) {
            this.pointActive = null;
            const list = [];
            for (let i = 0; i < results.getCurrentNumPois(); i++) {
                const item = results.getPoi(i);
                const regex = new RegExp(`(${this.searchValue})`, 'gi');
                item.title = item.title.replace(regex, '<span style="color:#00B955">$1</span>')
                list.push(item);
            }
            this.list = list;
        },

        searchFocus(event){
            this.searchTop = true;
            const verison = getIOSVersion();
            if(verison){
                setTimeout(() => {
                    window.scrollTo(0, 1);
                    event.target.focus();
                }, 200);
            }
        },
        searchBlur(event){
            const verison = getIOSVersion();
            if(verison){
                setTimeout(() => {
                    event.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }, 200);
            }
        },
        // 获取当前位置信息
        onClickPosition() {
            const pos = this.$route.query
            if (pos.lng) {
                const geocoder = new BMapGL.Geocoder();
                geocoder.getLocation(new BMapGL.Point(pos.lng, pos.lat), result => {
                    console.log("逆解析参数结果：", result)
                    if (!result) return;
                    this.pointActive = null;
                    const list = [];
                    for (let i = 0; i < result.surroundingPois.length; i++) {
                        const item = result.surroundingPois[i];
                        const regex = new RegExp(`(${this.searchValue})`, 'gi');
                        item.aTitle = item.title;
                        item.title = item.title.replace(regex, '<span style="color:#00B955">$1</span>')
                        list.push(item);
                    }
                    this.list = list;
                    // 移动设备传入的经纬度
                    this.location = { ...pos, address: list.length ? list[0].address : '' }
                    this.point = Object.assign({}, this.location)
                    this.onClickResult({ point: this.point, address: list.length ? list[0].address : '' }, 0)
                });
            }
        },

        // 点击搜索结果，并展示当前位置
        onClickResult(pos, index) {
            this.pointActive = index;
            this.searchTop = false;
            const posIcon = new this.BMapGL.Icon(pointIcon, new BMapGL.Size(30, 60));
            const point = new this.BMapGL.Point(pos.point.lng, pos.point.lat);
            const marker = new this.BMapGL.Marker(point, { icon: posIcon });        // 创建标注
            const offset = new this.BMapGL.Size(0, -20);
            marker.setOffset(offset);
            this.map.clearOverlays()
            this.map.addOverlay(marker)
            this.map.centerAndZoom(point, 18)
            this.point = { ...pos.point, address: pos.address }
        },

        onClickLeft() {
            this.toVersionRouter();
        },
        toVersionRouter(){
            const verison = getIOSVersion();
            if(verison){
                // 如已授权，去设置页面
                window.location.href = window.location.origin  +  `/patient/distanceLimit`
            }else{
                this.$router.replace({ path: `/distanceLimit`})
            }
        },

        async onClickRight() {
            if (!this.point.lng) return Toast('请先选择地理位置！')
            this.loading = true;
            const ret = await disLimitUpdate({
                longitude: this.point.lng,
                latitude: this.point.lat,
                mapLocationAddress: this.point.address? this.point.address : this.location.address,
                organSign: getCookie('native_organSign'),
            }).catch(err => { })
            this.loading = false;
            if (ret.data.result) {
                Toast('设置成功')
                this.toVersionRouter();
            } else {
                Toast(ret.data.msg || '设置失败')
            }
        }
    },
    watch: {
        searchValue(v) {
            if (!v) this.list = [];
            v && this.searchLocal && this.searchLocal.search(v)
        }
    }
}
</script>

<style lang="scss" scoped>

.map-container {
    height: 100vh;
    padding-bottom: 0;
    overflow: hidden;
    transition: padding-bottom 0.3s;
    -webkit-overflow-scrolling: touch;
    &.bottom-300{
        padding-bottom: 100px;;
    }
}
.map-navbar{
    position: sticky;
    top: 0;
    z-index: 20;
}

.flex {
    background: #FFFFFF;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .cancel {
        padding-right: 10px;
        white-space: nowrap;
        font-size: 14px;
        color: #111734;
    }
}

.nav-title {
    font-size: 16px;
    font-weight: 600;
}

.submitPos {
    color: #08BB5A;
    font-size: 16px;
}

.search-map {
    background: #FFFFFF;
    border-radius: 15px 15px 0 0;
    position: relative;
    z-index: 11;
    height: 40vh;
    transition: height .4s;
    overflow-y: auto;
    &.istop {
        border-radius: 0;
        position: absolute;
        top: 46px;
        width: 100%;
        height: calc(100vh - 46px);
    }
}

.search-box {
    background: transparent;
    width: 100%;

    .van-search__content {
        background: #F5F6FA;
        border-radius: 18.5px;
    }
}

.istop {
    .result-map {
        max-height: auto!important;;
    }
}

.result-map {
    z-index: 12;
    padding: 10px 16px 16px;
    height: 100%;
    max-height: calc(40vh - 54px);

    .result-item {
        padding: 10px;
        border-radius: 8px;

        &.activeMap {
            outline: 1px solid #08BB5A;
            background: #F4FFF9;
            position: relative;
        }

        .result-icon {
            position: absolute;
            right: 10px;
            top: 5px;
            color: #08BB5A;
        }

        .result-name {
            font-size: 16px;
            color: #111734;
            font-weight: 600;
            font-family: PingFangSC-Medium;
        }

        .result-address {
            font-size: 14px;
            color: #646566;
            margin-top: 6px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}

.no-result {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #969799;
    font-size: 16px;
}

.loading-box {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
}

.map-rela {
    position: relative;
    height: calc(60vh - 46px);
    overflow: hidden;
}

.map-store {
    width: 100%;
    height: calc(60vh + 40px);
}


.position-control {
    position: absolute;
    bottom: 20px;
    right: 20px;
    z-index: 11;
    width: 37px;
    height: 37px;
    background: #fff;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 1px 4px 0 #0d0d0d3b;

    .icon {
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -10px;
        margin-top: -10px;
        width: 20px;
        height: 20px;
        background: url(http://webmap0.bdimg.com/res/litemapapi/v1d1/images/loc_new.png?20190314) 0px 0px / 48px 116px;
    }
}
</style>